import axios from 'axios';
import type { AxiosInstance, AxiosRequestConfig, CancelToken } from 'axios';
import { ApiConfig, BaseApi } from './api.g';

export interface ClientGlobalSettingsResponse {
  referAFriendEnabled: boolean;
}

export class GlobalSettingsClient extends BaseApi {
  protected instance: AxiosInstance;
  protected baseUrl: string;

  constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {
    super(configuration);

    this.instance = instance || axios.create(this.commonConfig);
    this.baseUrl = baseUrl ?? this.getBaseUrl('https://api.hulk.cool');
  }

  get(cancelToken?: CancelToken): Promise<ClientGlobalSettingsResponse> {
    const options: AxiosRequestConfig = {
      method: 'GET',
      url: `${this.baseUrl}/api/ms/client/global-settings`,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance.request<ClientGlobalSettingsResponse>(options).then((response) => response.data);
  }
}
